export default "__VITE_ASSET__DF_5H5dl__"